<form name="change-password" [formGroup]="form" (ngSubmit)="save()" novalidate>
  <div class="row form-control-group">
    <div class="col">
      <label for="password" class="label" [ngClass]="{ 'form-required': form | ngxIsRequiredField: 'password' }" translate>
        password
      </label>
      <input
        id="password"
        type="password"
        class="nb-input"
        [placeholder]="'password' | translate"
        formControlName="password"
        nbInput
        fullWidth
      />
      <ngx-validation-message [group]="form" controlName="password" [validationMessages]="validationMessages"></ngx-validation-message>
    </div>
  </div>
  <div class="row form-control-group">
    <div class="col">
      <label for="confirm-password" class="label form-required" translate>
        confirm_password
      </label>
      <input
        id="confirm-password"
        type="password"
        class="nb-input"
        [placeholder]="'confirm_password' | translate"
        formControlName="confirmPassword"
        nbInput
        fullWidth
      />
      <ngx-validation-message
        [group]="form"
        controlName="confirmPassword"
        [validationMessages]="validationMessages"
      ></ngx-validation-message>
    </div>
  </div>
  <div class="row">
    <div class="col"><small class="form-required-tip" translate>form_required_tip</small></div>
  </div>
  <div class="form-submit-group">
    <button
      id="button-save"
      type="submit"
      [disabled]="loading"
      [nbSpinner]="loading"
      status="success"
      nbSpinnerSize="large"
      nbButton
      translate
    >
      save
    </button>
  </div>
</form>
